import { useStyles } from "./wrapper.style"
import { Container, CssBaseline } from "@fedsim/components"
import CookieConsent from "./consent"

import "./wrapper.css"

export default function LayoutWrapper({ children = "" }) {
  const classes = useStyles()

  return (
    <>
      <Container className={classes.root} disableGutters component='section'>
        <CssBaseline />
        <CookieConsent />
        <div className={classes.content}>{children}</div>
      </Container>
    </>
  )
}
